import React from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Link from '@mui/material/Link';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { setOpenSideBar } from 'handimap-react-lib/store/actions/sideBarActions';
import { SelectedDetails } from './SelectedDetails';
import theme from '../theme';
import { SearchAddress } from '../components/SearchAddress';
import { Options } from '../components/Options';
import { Directions } from '../components/Directions';
import { PathsCardsDetails } from './PathCardsDetails';
import { Roadmap } from './RoadMapSteps';
import { config } from 'handimap-react-lib/config';

export const SideBarContent = ({
  isMobile, 
  status,
  allResults,
}) => {
  const {t} = useTranslation();
  const contentType = useSelector(state => state.sideBar.contentType);
  const selectedFeature = useSelector(state => state.selectedFeature);
  const {selected, feature, backSection} = selectedFeature;
  
  const selectedPath = useSelector(state => state.directions.selectedPath);

  const dispatch = useDispatch();

  const {palette, buttonSwitch} = theme;

  const styleSwitch = {
    backgroundActive: buttonSwitch.backgroundActiveColor,
    activeThumbColor: buttonSwitch.activeThumbColor,
    background: buttonSwitch.backgroundColor,
    thumb: buttonSwitch.thumbColor,
    primary: palette.primary.main,
    primaryContrast: palette.primary.contrastText,
    secondary: palette.secondary.main,
    secondaryContrast: palette.secondary.contrastText

  };

  const styles = {
    container : {
      display: 'flex',
      maxWidth: '100%',
      flex: 1,
      marginY: isMobile ? '1em' : '2em'
    },
    logoContainer : {
      display: 'flex',
      width: '100%',
      justifyContent: 'center',
      marginY : '2em'
    },
    stackSide : {
      display: 'flex',
      width: '100%',
      flexGrow: 1,
    },
    closeMobileContainer : {
      display: 'flex',
      justifyContent: 'flex-end'
    }
  };

  return (
    <Box sx={styles.container}>
      <Stack sx={styles.stackSide} direction='column' spacing={2}>
        {isMobile && contentType === 'direction' && (
          <Box sx={styles.closeMobileContainer}>
            <IconButton 
              id='close_sidebar'
              aria-label={t('side-bar.aria-close-label')}
              onClick={() => dispatch(setOpenSideBar(false))}
            >
              <CloseIcon  />
            </IconButton>
          </Box>
        )}
        { contentType === 'direction' &&
        <React.Fragment>
          <Tooltip   
            title={
              <p style = {{
                fontSize: '1em',
              }}>
                {t('side-bar.aria-back-home')}
              </p>
            } 
            placement={isMobile ? 'top-end' : 'bottom'}
            arrow>
            <Link aria-label={t('side-bar.aria-back-home')} sx={styles.logoContainer} 
            
              href={`${config.url.HOME_PAGE_URL}`}>
              <img style={{width: '50%', height: 'auto'}} src={config.url.PUBLIC_URL + '/logo.png'} alt=''  />
            </Link>
          </Tooltip>
          <SearchAddress />
          <Options 
            isMobile={isMobile} 
            showCondition={true}
          />
          <Directions 
            isMobile={isMobile}
            styleSwitch={styleSwitch} />
          <PathsCardsDetails
            status={status}
            allResults={allResults}
            selectedPath={selectedPath}
          />
          {/* <ListSuggestions isMobile={isMobile} /> */}
        </React.Fragment>
        }
        { contentType === 'stepsDetails' &&
        <Roadmap
          status={status} 
          allResults={allResults} 
          selectedPath={selectedPath}
          isMobile={isMobile}
        />
        }
        { selected && contentType !== 'stepsDetails' && contentType !== 'direction' && (
          <SelectedDetails 
            isMobile={isMobile} 
            status={status}
            contentType={contentType}
            feature={feature}
            backSection={backSection} />
        )}
      </Stack>
    </Box>
  );
};